import React from 'react';
import InvestmentLocations from '../InvestmentLocations';

import OverviewMap from 'oldAssets/images/static_pages/investment_locations/berlin/overview-map-berlin.webp';

import Siemens from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/Siemens.webp';
import Zalando from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/Zalando.webp';
import Ebay from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/Ebay.webp';

import TUberlin from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/TUberlin.webp';
import UniversitatDerKunste from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/UniversitatDerKunste.webp';
import htwBerlin from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/htwBerlin.webp';

import SiemensLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/siemens.svg';
import ZalandoLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/zalando.svg';
import EbayLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/ebay.svg';

import TUBerlinLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/tu-berlin.svg';
import UDKBerlinLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/udk-berlin.svg';
import HTWBerlinLogo from 'oldAssets/images/static_pages/investment_locations/berlin/organizations/htw-berlin.svg';

import EmployersMap from 'oldAssets/images/static_pages/investment_locations/berlin/employers-map-berlin.webp';
import UniversitiesMap from 'oldAssets/images/static_pages/investment_locations/berlin/universities-map-berlin.webp';

import ExceptionPhoto from 'oldAssets/images/static_pages/investment_locations/berlin/exception-berlin.webp';

/*eslint max-lines-per-function: ["error", 200]*/
const BerlinPage = (props) => {
  const { work, universities, exception, overview } = props;

  const employersPhotos = [Siemens, Zalando, Ebay];
  const employersLogos = [SiemensLogo, ZalandoLogo, EbayLogo];

  const universitiesPhotos = [TUberlin, UniversitatDerKunste, htwBerlin];
  const universitiesLogos = [TUBerlinLogo, UDKBerlinLogo, HTWBerlinLogo];

  const context = require.context('oldAssets/images/static_pages/investment_locations/berlin/gallery', 
    false, /.+\.webp$/);

  return (
    <InvestmentLocations
      { ...props }
      pageName="Berlin"
      overview={{
        data: overview,
        map: OverviewMap,
        context,
        link: 'https://immobilien-tipps.wunderagent.de/?s=Berlin'
      }}
      work={{
        data: work,
        photos: employersPhotos,
        logos: employersLogos,
        map: EmployersMap
      }}
      universities={{
        data: universities,
        photos: universitiesPhotos,
        logos: universitiesLogos,
        map: UniversitiesMap
      }}
      exception={{
        data: exception,
        photo: ExceptionPhoto
      }}
    />);
};

export default BerlinPage;
